<template>
  <layout title="Users">
    <div class="row">
      <div class="col-10">
        <h2 class="page-heading">
          <inertia-link
            class="previous-path-header"
            :href="route('users.index')"
          >
            Users
          </inertia-link>
          / Import
        </h2>
      </div>
      <div class="col-2">
        <inertia-link
          class="btn btn-primary float-right"
          :href="route('users.index')"
        >
          Back
        </inertia-link>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-10">
            <FlashMessage
              :flash="
                flash && (flash.success || flash.error)
                  ? flash
                  : { error: errors.file }
              "
            />

            <div>
              <h5>Sample data sheet</h5>
              <img
                src="/images/import.png"
                title="Import"
                class="image-fluid w-100"
              />
            </div>
            
            <div class="form-group">
              <FileUploader @submitted="handleFileUploadSubmit" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import FileUploader from "../../Components/FileUploader";

export default {
  layout: AppLayout,
  props: {
    errors: Object,
    flash: Object,
  },
  components: {
    FileUploader: FileUploader,
  },
  data() {},
  methods: {
    handleFileUploadSubmit(files) {
      let data = new FormData();

      data.append("file", files[0]);

      this.$inertia.post(route("users.import.submit"), data);

      // data.append("session_id", this.session.id);
      // data.append("main_content", this.isMainContent);

      // for (let i = 0; i < files.length; i++) {
      //   data.append("content_files[]", files[i]);
      // }

      // this.$inertia.post(
      //   route("classrooms.sessions.content.add", this.session.id),
      //   data
      // );
    },
  },
};
</script>
